import React from 'react'
import { SIGNUP_URL } from '../../config/links';
import './header.css';

const Header = () => {
  return (
    <div className="header-container">
    <div className="MuaythaiHeader">
      <div className="Muaythai-text">
        <h1 className="Muaythai-words">
          AMS Muaythai at UBC was founded in 2022 
          with the goal of promoting physical and 
          mental health throughout the UBC community.
          </h1>
      </div>
      <div className="Muaythai-button">
      <a className="signup-cta" href={SIGNUP_URL} target="_blank" rel="noopener noreferrer">Sign Up</a>
      </div>
    </div>
    </div>
  )
}

export default Header